import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

type Props = SvgIconProps & {
  circleFillColor: string
  letterFillColor: string
}

export const InfoColored: FC<Props> = ({ circleFillColor, letterFillColor, ...rest }: Props) => (
  <SvgIcon width="24" height="24" fill="none" {...rest}>
    <path d="M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12z" fill={circleFillColor} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.823 17.38V9.617h2.354v7.761h-2.354zm0-9.088V6.207h2.354v2.085h-2.354z"
      fill={letterFillColor}
    />
  </SvgIcon>
)
